import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import SidebarTooltip from './SidebarTooltip';
import { Tooltip } from 'reactstrap';
import SubMenuBar from './SubMenuBar';
import { useRef } from 'react';
import { useEffect } from 'react';

const SidebarMenu = ({ index, isActive, id }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);
    const handleDropdownClick = () => {
        setIsOpen((prevState) => !prevState); // Toggle the dropdown state
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false); // Close the dropdown when clicking outside of it
        }
    };

    useEffect(() => {
        // Attach the event listener when the dropdown is open
        if (isOpen) {
            document.addEventListener('click', handleClickOutside);
        }

        // Clean up the event listener when the dropdown is closed
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isOpen]);
    return (
        <div ref={dropdownRef}>
            <NavLink to={index.link}
                id={'Tooltip-' + id}
                onClick={handleDropdownClick} activeclassname="active" className={`${isActive ? "sidebar-link-active" : "sidebar-link justify-content-between"} ${isOpen ? "subMenu-active" : ""}`}>
                <span className="d-flex gap-3 align-items-center">
                    <span >
                        {index.icon}
                    </span>
                    <h1 className={`mb-0 title-font-700 fs-36 ${isActive && "title-none"}`}>{index.title}
                    </h1>
                </span>
                {!isActive ?
                    <div className="">
                        {
                            isOpen ? <i className='bx bx-chevron-up icon-size fw-700'></i> : <i className='bx bx-chevron-down icon-size fw-700'></i>
                        }

                    </div>
                    : <div className="d-none dropdown-icons">
                        {
                            isOpen ? <i className='bx bx-chevron-up icon-size fw-700'></i> : <i className='bx bx-chevron-down icon-size fw-700'></i>
                        }

                    </div>
                }
            </NavLink>
            {
                isActive &&
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target={'Tooltip-' + id}
                    toggle={toggle}
                >
                    <span className="fs-3 px-2 py-1 title-font-500 border-0">{index.title}</span>
                </Tooltip>
            }

            {!isActive ?
                <div className={`${isOpen ? "subMenu-card" : "subMenu-card-close"}`}>
                    {
                        isOpen &&
                        index?.childs?.map((index, i) => {
                            if (index?.subchilds) {
                                return <SubMenuBar key={i} id={i} index={index} isActive={isActive} />
                            }
                            return (
                                <NavLink to={index.link} key={i} activeclassname="active" className={`${isActive ? "sidebar-link-active" : "sidebar-link-menu"} `}>
                                    <span className="">
                                        {index.icon}
                                    </span>
                                    <h1 className={`mb-0 title-font-600 fs-4 ${isActive && "title-none"}`}>{index.title}
                                    </h1></NavLink>


                            )
                        })
                    }
                </div> :
                <div className={`${isOpen ? "subMenu-card" : "subMenu-card-close"}`}>
                    {
                        isOpen &&
                        index.childs.map((index, i) => {
                            return (
                                <SidebarTooltip key={i} index={index} id={i + 20} isActive={isActive} />
                            )
                        })
                    }
                </div>
            }

        </div>
    )
}

export default SidebarMenu